<template>
  <v-container fluid v-if="!loading">
    <v-card>
      <v-card-title>Artigo</v-card-title>
      <v-card-text>
        <!-- Vuetify 3 Stepper -->
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-item :complete="e1 > 1" step="1">
              Definir dados globais
            </v-stepper-item>

            <v-divider></v-divider>

            <v-stepper-item :complete="e1 > 2" step="2">
              Conteúdo do artigo
            </v-stepper-item>

            <v-divider></v-divider>

            <v-stepper-item step="3">
              Configurações
            </v-stepper-item>
          </v-stepper-header>

          <v-stepper-window>
            <!-- Step 1 -->
            <v-stepper-window-item value="1">
              <v-row class="mt-4">
                <v-col cols="12">
                  <v-text-field
                    v-model="globalVars.articleID"
                    label="Dá um ID único ao teu artigo"
                    :disabled="disabledArticle"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="globalVars.data" label="Data" />
                </v-col>
                <v-col cols="12" class="text-right">
                  <v-btn
                    color="success"
                    :disabled="!globalVars.articleID || !globalVars.data"
                    @click="addID"
                  >
                    Seguinte
                    <v-icon class="ml-2">mdi-arrow-right-circle</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-stepper-window-item>

            <!-- Step 2 -->
            <v-stepper-window-item value="2" v-if="globalVars.articleID">
              <v-row align="center">
                <v-col cols="12" class="text-center">
                  <span class="text-h3">Escreve o teu artigo</span>
                </v-col>
              </v-row>

              <!-- Tabs -->
              <v-tabs v-model="tab" grow color="primary">
                <v-tab v-for="language in languages" :key="language">{{ language }}</v-tab>
              </v-tabs>

              <v-window v-model="tab">
                <v-window-item v-for="language in languages" :key="language" :value="language">
                  <v-row v-if="!lockedArticle" class="mt-8">
                    <v-col cols="12">
                      <v-text-field v-model="article[language].title" label="Título do artigo" />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="article[language].subtitle" label="Sub-título do artigo" />
                    </v-col>
                    <v-col cols="12">
                      <v-tiptap v-model="article[language].body" />
                    </v-col>
                  </v-row>
                </v-window-item>
              </v-window>

              <v-row class="mt-4">
                <v-col cols="12" class="text-right">
                  <v-btn color="error" @click="e1 = 1">
                    Voltar
                    <v-icon class="ml-2">mdi-arrow-left-circle</v-icon>
                  </v-btn>
                  <v-btn color="success" @click="e1 = 3">
                    Seguinte
                    <v-icon class="ml-2">mdi-arrow-right-circle</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-stepper-window-item>

            <!-- Step 3 -->
            <v-stepper-window-item value="3" v-if="globalVars.articleID">
              <v-card flat>
                <v-card-title>
                  <v-alert type="error" border="start" variant="tonal" class="w-100">
                    <span class="text-h4">ATENÇÃO!</span><br />
                    Para a imagem ser bem colocada, certifica-te de criares uma pasta com o nome <br />
                    <span class="text-h6"><strong>"{{ getFolderName() }}"</strong></span><br />
                    dentro da pasta <br />
                    <span class="text-h6"><strong>"src/json_articles/images"</strong></span>
                  </v-alert>
                </v-card-title>

                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="globalVars.autor"
                        :items="autores"
                        item-value="id"
                        item-title="autor"
                        label="Autor"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field v-model="globalVars.photo" label="Insira o caminho da imagem" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn color="error" @click="e1 = 2">
                    Voltar
                    <v-icon class="ml-2">mdi-arrow-left-circle</v-icon>
                  </v-btn>
                  <v-btn color="success" @click="submit">
                    Concluir
                    <v-icon class="ml-2">mdi-check-circle</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-stepper-window-item>
          </v-stepper-window>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import articles from '@/json_articles/articles.json'

const route = useRoute()
const { locale } = useI18n({ useScope: 'global' })

const disabledArticle = ref(true)
const autores = ref([
  { id: 'Erbi', autor: 'Erbi Silva', autor_photo: 'erbi.jpeg', author_id: 'Erbi' },
  { id: 'Alvaro', autor: 'Alvaro Vaz', autor_photo: 'alvaro_new.png', author_id: 'Alvaro' },
])

const e1 = ref(1)
const tab = ref(0)
const languages = ref([])
const lockedArticle = ref(true)
const loading = ref(true)

const globalVars = reactive({
  articleID: null,
  data: null,
  photo: null,
  autor: null,
})

const article = reactive({
  pt: { id: '', data: '', title: '', subtitle: '', body: '', foto: '', autor_id: '', autor: '', author_id: '', autor_photo: '' },
  en: { id: '', data: '', title: '', subtitle: '', body: '', foto: '', autor_id: '', autor: '', author_id: '', autor_photo: '' },
})

onMounted(() => {
  if (route.params.article_id !== 'article') {
    disabledArticle.value = true
    loadArticle()
  } else {
    disabledArticle.value = false
  }

  languages.value = import.meta.env.VITE_I18N_FALLBACK_LOCALE.split(',')
  loading.value = false
})

function getFolderName() {
  let full_name = globalVars.articleID.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  full_name = full_name.replaceAll(' ', '-')
  return full_name
}

function downloadJSON() {
  const data = JSON.stringify(articles)
  const blob = new Blob([data], { type: 'application/json' })
  const a = document.createElement('a')
  a.download = 'articles.json'
  a.href = URL.createObjectURL(blob)
  a.click()
}

function submit() {
  const selectedAutor = autores.value.find(a => a.id === globalVars.autor)

  languages.value.forEach(lang => {
    article[lang].foto = globalVars.photo
    article[lang].autor_id = selectedAutor.id
    article[lang].autor = selectedAutor.autor
    article[lang].author_id = selectedAutor.author_id
    article[lang].autor_photo = selectedAutor.autor_photo
  })

  if (route.params.article_id !== 'article') {
    languages.value.forEach(lang => {
      articles.articles.forEach(ar => {
        if (ar[lang].id === route.params.article_id) {
          ar[lang] = article[lang]
        }
      })
    })
  } else {
    articles.articles.unshift(article)
  }

  downloadJSON()
}

function addID() {
  globalVars.articleID = getFolderName()
  languages.value.forEach(lang => {
    article[lang].id = globalVars.articleID
  })
  lockedArticle.value = false
  e1.value = 2
}

function loadArticle() {
  articles.articles.forEach(el => {
    if (el[locale.value].id === route.params.article_id) {
      Object.assign(article, el)
    }
  })
  globalVars.data = article[locale.value].data
  globalVars.articleID = article[locale.value].id
}
</script>
